export { default } from './BarChart.js';
